/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TranscoderDataRequest } from '../models/TranscoderDataRequest';
import { HttpFile } from '../http/http';

export class PatchedHorseActivityVideoRequest {
    'activity'?: number;
    'name'?: string;
    'video'?: HttpFile;
    'transcoded'?: TranscoderDataRequest;
    'thumbnail'?: HttpFile;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "activity",
            "baseName": "activity",
            "type": "number",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "video",
            "baseName": "video",
            "type": "HttpFile",
            "format": "binary"
        },
        {
            "name": "transcoded",
            "baseName": "transcoded",
            "type": "TranscoderDataRequest",
            "format": ""
        },
        {
            "name": "thumbnail",
            "baseName": "thumbnail",
            "type": "HttpFile",
            "format": "binary"
        }    ];

    static getAttributeTypeMap() {
        return PatchedHorseActivityVideoRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

